import React, { useState, useEffect } from 'react';
import cart_g from '../../img/cart_g.png';
import cart_w from '../../img/cart_w.png';
import cart_b from '../../img/cart_b.png';
import { instance } from '../../common';

function Cart_bg({ u_id, s_id, goCart, s_name, cart }) {
  let obj = {
    u_id: u_id,
    s_id: s_id,
  };

  const [data, setData] = useState([]);
  useEffect(() => {
    const fetchData = async () => {
      instance.post('/cart/cart_bg', obj).then(function (res) {
        console.log('chk : ', res.data);
        setData(res.data);
      });
    };

    fetchData();
  }, [goCart]);

  return (
    <>
      {data.map((v) =>
        v.cnt == 1 ? (
          <img
            style={cart}
            src={cart_b}
            onClick={goCart}
            data-id={s_id}
            data-name={s_name}
          />
        ) : (
          <img
            style={cart}
            src={cart_g}
            onClick={goCart}
            data-id={s_id}
            data-name={s_name}
          />
        )
      )}
    </>
  );
}

export default Cart_bg;
